import React, { useState, useEffect } from "react";
import "../styles/Navbar.css";

function Navbar({ toggleLeftSidebar }) {  // Accept toggleLeftSidebar as a prop
   // Set default theme to light
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("theme") === "dark"; // Default is light mode
  });

  useEffect(() => {
    const container = document.querySelector(".container");
    if (darkMode) {
      container.classList.add("dark-theme");
      container.classList.remove("light-theme");
    } else {
      container.classList.add("light-theme");
      container.classList.remove("dark-theme");
    }
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  return (
    <nav className="navbar">
      <h1>FerHub</h1>
      <div className="right-section">
        <button className="theme-toggle" onClick={() => setDarkMode(!darkMode)}>
          {darkMode ? "☀️" : "🌙"}
        </button>
        <button className="hamburger-btn" onClick={toggleLeftSidebar}>☰</button> {/* Visible only on narrower screens */}
      </div>
    </nav>
  );
}

export default Navbar;
